import React, { useEffect, useState } from 'react';

import { StandardButton } from '../common/button/standard-button/StandardButton';
import { LeftLabelToggle } from '../common/input/left-label-toggle/LeftLabelToggle';

import { updateSystemUserSettings } from '../../services/AccountService';

import './Settings.css';

export const Settings = ({ context, setContext, setSpinnerText, showToaster }) => {
  const [tooltipsEnabled, setTooltipsEnabled] = useState(context.loggedInUser.toolTipsEnabled);

  useEffect(() => {
    setTooltipsEnabled(context.loggedInUser.toolTipsEnabled);
  }, [context.loggedInUser.toolTipsEnabled]);

  const handleSaveClick = async () => {
    setSpinnerText('Updating Settings');

    const systemUserVOToUpdate = {
      externalReference: context.loggedInUser.externalReference,
      toolTipsEnabled: tooltipsEnabled,
    };

    const response = await updateSystemUserSettings(context.username, systemUserVOToUpdate);

    handleResponse(response);
  };

  const handleResponse = ([data, error]) => {
    if (data) {
      if (data.responseStatus === 'Success') {
        setContext((prevState) => ({
          ...prevState,
          loggedInUser: {
            ...prevState.loggedInUser,
            toolTipsEnabled: tooltipsEnabled,
          },
        }));
      }

      showToaster(data);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }

    setSpinnerText(null);
  };

  return (
    <div className="settings-container">
      <div className="settings-content-container">
        <LeftLabelToggle labelText="Show Tooltips:" active={tooltipsEnabled} setActive={setTooltipsEnabled} />

        <div className="settings-button-container">
          <StandardButton text="Save Settings" onClick={handleSaveClick} />
        </div>
      </div>
    </div>
  );
};
